/**
 * Action types for LOA Redux
 */
export const SET_LOA_DATA = "SET_LOA_DATA";
export const LOA_LIST_FETCHING_INIT = "LOA_LIST_FETCHING_INIT";
